// extracted by mini-css-extract-plugin
module.exports = {"container":"TarteelAttribution_container__pV6Dr","poweredBy":"TarteelAttribution_poweredBy__HGAKn","tarteelTextWrapper":"TarteelAttribution_tarteelTextWrapper__GH8ML"};